import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {PageMeta} from './routing/PageMeta'
import '../global.css'
import 'rsuite/DateRangePicker/styles/index.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
flatpickr.localize(Portuguese);


const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <PageMeta />
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
          <ToastContainer 
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
